import { ProductBatchLogStatusEnum } from "@c2b/muven-commons";

export class ProductBatchItemLogModel {
	id: string = '';
	idProductBatch: string = '';
	createdAt: string|Date = '';
	status: ProductBatchLogStatusEnum = ProductBatchLogStatusEnum.Success;
	info: {
		item: {
			id: string;
			name: string;
			codeSource?: string|null;
			skuCode?: string|null;
			idSourceSku: string;
		},
		message: string;
	} = {
		item: {
			id: '',
			name: '',
			idSourceSku: '',
			codeSource: null,
			skuCode: null,
		},
		message: '',
	}

	constructor(pl?: Partial<ProductBatchItemLogModel>) {
		Object.assign(this, pl)
	}

	isStatusSuccess():boolean {
		return this.status === ProductBatchLogStatusEnum.Success
	}

	isStatusError():boolean {
		return this.status === ProductBatchLogStatusEnum.Error
	}

	isStatusWarning():boolean {
		return this.status === ProductBatchLogStatusEnum.Warning
	}

	isStatusIgnored():boolean {
		return this.status === ProductBatchLogStatusEnum.Ignored
	}
}
